import styled from 'styled-components';

export const Chips = styled.div`
  > div {

  }
`;

export const Field = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const ComplianceIconWrapper = styled.span`
  position: absolute;
  right: 4px;
  bottom: ${p => p.centered ? 'calc(50% - 10px)' : '4px'};
  width: 20px;
  height: 20px;
`;
